<template>
<div class="focused-panel">
  <div class="d-flex polytron-toolbar">
    <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create polygon" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select polygon" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete poly" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>
  </div>

  <b-modal no-close-on-backdrop no-close-on-esc v-model="showForm" :title="formTitle" @ok="onOK" @cancel="onCancel">
    <div slot="modal-header">
      <label>{{formTitle}}</label>
      <!-- <div v-if='editablePhase'>
          <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
          </div>

          <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
          </div>
        </div> -->
    </div>
    <div class="p-2">
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="Name:">
              <b-form-input id="batch_name" v-model="wellAttrs['batch_name']" placeholder="Enter batch name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>

            <b-form-group label="Cwp Name:">
              <b-form-input id="cwpname" v-model="wellAttrs['cwpname']" placeholder="Enter cwpname"></b-form-input>
            </b-form-group>
          </b-col>

        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Batch Online Year:">
              <b-form-input id="batch_year" v-model="wellAttrs['batch_online_year']" placeholder="Enter batch online year"></b-form-input>
            </b-form-group>
          </b-col>
          <!-- <b-col>
            <b-form-group label="Batch:">
              <b-form-input id="batch" v-model="wellAttrs['batch']" placeholder="Enter batch"></b-form-input>
            </b-form-group>
          </b-col> -->
        <!-- </b-row>
        <b-row> -->
          <!-- <b-col>
            <b-form-group label="Desc:">
              <b-form-input v-model="wellAttrs['desc']" />
            </b-form-group>
          </b-col> -->
          <b-col>
            <b-form-group label="Gas Destination:" label-for="gas-dest-select" class="gas-dest-select">
              <b-form-select :options="gasDestOptions" id="gas-dest-select" v-model="gas_dest" placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Sequence:">
              <b-form-input id="sequence" type="range" v-model="wellAttrs['sequence']" placeholder="Enter sequence" min="1" max="19"></b-form-input>
              <div class="mt-2">Sequence value: {{ wellAttrs['sequence'] }}</div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="AWP Status:" label-for="awp-status-select" class="awp-status-select">
              <b-form-select :options="awpStatusOptions" id="awp-status-select" v-model="wellAttrs['awp_status']" placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-checkbox :unchecked-value="false" :value="true" v-model="wellAttrs['exclude_from_export']" size="sm">Exclude batch from Exports</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </b-modal>

</div>
</template>

<script>
import 'vue-awesome/icons/arrows-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/check'
import Vue from 'vue'

import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import uuidV1 from 'uuid/v1'

export default {
  name: 'polytron',
  components: {

  },
  mixins: [FeatureEditorMixin],
  data() {
    return {
      markLastModified: false,
      featureId: null,
      addPolyEnabled: false,
      addLineEnabled: false,
      addPointEnabled: false,
      wellAttrs: {
        cwpname: null,
        // desc: '',
        batch_name: '',
        field_name: null,
        batch_online_year: null,
        // batch: null,
        sequence: null,
        awp_status: null,
        exclude_from_export: false
      },
      options: [],
      causes: [],
      wellLayerName: 'v4:managementpoly_planning',
      geometryName: 'geom',
      idName: 'gid',
      geomType: 'Polygon',
      identName: 'batch_name',
      gasDestOptions: [],
      awpStatusOptions: [
        '',
        'AAP',
        'AAS',
        'AWP',
        'FLA',
        'NYS',
        'SA',
        'Seeking Agreements',
        'RFS',
        'IFD',
        'IFC'
      ],
      gas_dest: 0,
      awp_status: ''
    }
  },
  methods: {
    editProps(feature) {
      this.featureId = feature.get('gid')
      FeatureEditorMixin.methods.editProps.call(this, feature)
    },
    getCurrentGasDest() {
      try {
        this.gas_dest = this.gasDestOptions.find(o => o.text.toLowerCase() == this.wellAttrs['field_name'].toLowerCase()).value
      } catch(error) {
        console.log('No matching gas dest')
        // console.log(error)
        this.gas_dest = 0
      }
    },
    loadGasOptions() {
      this.$http.get('/api/layers/gas-dest-options').then(res => {
        let fil = res.body.filter(f => f.subject)
        this.gasDestOptions = fil.map(m => {
          return {
            text: m.subject,
            value: m.subject
          }
        })
        this.gasDestOptions = this.gasDestOptions.concat({
          text: 'None',
          value: 0
        })
        this.getCurrentGasDest()
      }, res => {
        console.log('Error Thrown')
        console.log(res)
      })
    },
  },
  watch: {
    showForm(val) {
      if (val && this.gasDestOptions.length === 0) {
        this.loadGasOptions()
      } else {
        this.getCurrentGasDest()
      }
    },
    gas_dest(val) {
      if (val != this.wellAttrs['field_name']) {
        this.wellAttrs['field_name'] = val
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/Polytron.vue